import React, { useState, useEffect } from 'react'
import NiceModal, { useModal } from '@ebay/nice-modal-react'
import { Modal, Input, Select, Button, MarkdownTextArea } from '@arnsbogroup/react-voicearchive'
import { useIntl } from 'react-intl'
import messages from './messages'

export default NiceModal.create(({ onSave = null }) => {
  const modal = useModal()
  const { formatMessage } = useIntl()

  const [title, setTitle] = useState('')
  const [body, setBody] = useState('')
  const [userType, setUserType] = useState(null)
  const [partner, setPartner] = useState(null)
  const [tags, setTags] = useState([])
  const [partnerOptions, setPartnerOptions] = useState([])
  const [tagOptions, setTagOptions] = useState([])
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState(null)

  const userTypeOptions = [
    { value: 1, label: formatMessage(messages.userTypeCoordinator) },
    { value: 4, label: formatMessage(messages.userTypeCustomer) },
    { value: 3, label: formatMessage(messages.userTypeSupplier) },
  ]

  useEffect(() => {
    setUserType(userTypeOptions[0])

    fetch('/rest/v2/partner')
      .then((r) => r.json())
      .then(( data ) => {
        setPartnerOptions([
          { value: null, label: formatMessage(messages.partnerAll) },
          ...(data || []).map((p) => ({ value: p.uid, label: p.name })),
        ])
        setPartner({ value: null, label: formatMessage(messages.partnerAll) })
      })

    fetch('/rest/v2/tag?pageSize=200')
      .then((r) => r.json())
      .then((res) => {
        const list = Array.isArray(res) ? res : res.data || []
        setTagOptions(list.map((t) => ({ value: t.uid, label: t.name })))
      })
  }, [])

  const handleSubmit = async () => {
    setError(null)
    setSaving(true)

    const res = await fetch('/rest/v2/announcement', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        title,
        body,
        usergroup: userType?.value ?? 4,
        partner_uid: partner?.value ?? null,
        tag_uids: tags.map((t) => t.value),
      }),
    }).then((r) => r.json())

    setSaving(false)

    if (res.success) {
      modal.remove()
      onSave?.()
    } else {
      setError((res.errors || []).join(', ') || 'Something went wrong')
    }
  }

  return (
    <Modal
      show={modal.visible}
      title={formatMessage(messages.title)}
      onClose={() => modal.remove()}
      dialogPanelClasses="max-w-2xl"
    >
      <div className="space-y-4">
        <Input
          label={formatMessage(messages.fieldTitle)}
          required
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />

        <div className="grid grid-cols-2 gap-4">
          <Select
            label={formatMessage(messages.fieldUserType)}
            required
            value={userType}
            options={userTypeOptions}
            onChange={setUserType}
          />
          <Select
            label={formatMessage(messages.fieldPartner)}
            value={partner}
            options={partnerOptions}
            onChange={setPartner}
            isClearable
          />
        </div>
        <Select
          label={formatMessage(messages.fieldTags)}
          isMulti
          value={tags}
          options={tagOptions}
          onChange={setTags}
        />
        <MarkdownTextArea
          label={formatMessage(messages.fieldBody)}
          required
          value={body}
          onChange={setBody}
        />

        {error && (
          <p className="text-sm text-red-600">{error}</p>
        )}

        <div className="flex justify-end space-x-2 pt-2">
          <Button variant="outline" onClick={() => modal.remove()}>
            {formatMessage(messages.cancel)}
          </Button>
          <Button
            disabled={!title || !body || saving}
            onClick={handleSubmit}
          >
            {formatMessage(messages.create)}
          </Button>
        </div>
      </div>
    </Modal>
  )
})
